<template>
  <!-- 表单容器 -->
  <div class="form-container" :style="formContainerStyle">
    <!-- 表单 -->
    <div class="form">
      <div class="form-title">
        <span>{{ currentRoute.meta.stepName }}</span>
      </div>
      <div class="form-box">
        <router-view v-slot="{ Component }">
          <keep-alive :include="keepAliveRoutes" :exclude="excludeRoutes">
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </div>
      <footer-btn ref="footerBtnRef">
        <van-action-bar>
          <van-action-bar-button type="primary" :disabled="subBtnDisable" block @click="clickStep">
            <!--下一步签约医生-->
            {{ signMode === SignModeEnum.sync ? '完成' : '下一步签约医生' }}
          </van-action-bar-button>
        </van-action-bar>
      </footer-btn>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'RecordBasicInfo',
};
</script>
<script lang="ts" setup>
import { router } from '@/router';
import FooterBtn from '@/views/widget/FooterBtn.vue';
import { useRecordsStore } from '@/store/modules/records';
import { showToast } from 'vant';
import { useContractStore } from '@/store/modules/contract';
import { onBeforeRouteLeave, useRouter } from 'vue-router';
import { keepAliveRoutes, excludeRoutes, addRouteToExclude, recoverKeepAlive } from '@/router/routes';
import { ProfileStatusEnum, RecordsActionTypeEnum, SignModeEnum } from '@/enums/CommonEnum';
import { useConfigStore } from '@/store/modules/config';
import { debounce } from '@tencent/fd-utils';

const configStore = useConfigStore();
const { currentRoute } = useRouter();
const recordsStore = useRecordsStore();
const contractStore = useContractStore();
const footerBtnRef = ref<any>(null);
const formContainerStyle = computed(() => {
  return {
    paddingBottom: `${(footerBtnRef.value?.height ?? 0) + 12}px`,
  };
});
const signMode = configStore.dict?.dynamicConfig?.feSysConfig?.signMode;
const { required } = configStore;
const recordsStatus = recordsStore.getRecords?.profileStatus === ProfileStatusEnum.recorded;
const subBtnDisable = computed(() => !recordsStatus && !recordsStore.checkStepValue(required));
const clickStep = debounce(async () => {
  if (!recordsStore.getRecords) return;
  if (!recordsStatus) {
    const { valid, msg } = recordsStore.validStepValue(required);
    if (!valid) {
      return showToast(msg);
    }
  }
  let res;
  // 原有逻辑是，verify如果返回有id值，就走更新逻辑，否则走创建逻辑
  // if (recordsStore.getRecords.id > 0) {
  // 现逻辑修改为：
  // 如果交互流程是从上传身份证开始，一步步向下走，在档案处就调用创建接口
  // 否则调用更新
  // 因从签约页上一步到建档页时，会传入profileId，所以可以通过profileId值来判断这一场景
  if (contractStore.profileId) {
    // profileStatus 为 1 时，档案不可编辑
    // 这个值只在更新场景用于判断，创建场景不用判断
    if (recordsStore.getRecords.profileStatus !== ProfileStatusEnum.recorded) {
      res = await recordsStore.updateProfile({
        id: recordsStore.getRecords.id ? recordsStore.getRecords.id : contractStore.profileId, // 兼容从身份证验真一直向下，后又返回上一步，取不到id的场景
        phone: recordsStore.getRecords.phone,
        registerType: recordsStore.getRecords.registerType,
        nation: recordsStore.getRecords.nation,
        birthday: recordsStore.getRecords.birthday,
        registerAddress: recordsStore.getRecords.registerAddress,
        addressCode: recordsStore.getRecords.addressCode,
        address: recordsStore.getRecords.address,
        signOrg: recordsStore.getRecords.signOrg,
        job: recordsStore.getRecords.job,
        payMode: recordsStore.getRecords.payMode,
        employer: recordsStore.getRecords.employer,
        education: recordsStore.getRecords.education,
        marital: recordsStore.getRecords.marital,
        contactsName: recordsStore.getRecords.contactsName,
        contactsPhone: recordsStore.getRecords.contactsPhone,
        fullName: recordsStore.getRecords.fullName,
        gender: recordsStore.getRecords.gender,
        insuranceType: recordsStore.getRecords.insuranceType,
        insuranceNo: recordsStore.getRecords.insuranceNo,
        height: recordsStore.getRecords.height,
        weight: recordsStore.getRecords.weight,
        waistline: recordsStore.getRecords.waistline,
        onSitePhoto: recordsStore.getRecords.onSitePhoto,
        extFields: recordsStore.getRecords.extFields,
      });
      console.log('xxx-res-update', res);
    }
  } else {
    res = await recordsStore.create({
      certType: recordsStore.getRecords.certType,
      certNo: recordsStore.getRecords.certNo,
      fullName: recordsStore.getRecords.fullName,
      phone: recordsStore.getRecords.phone,
      gender: recordsStore.getRecords.gender,
      registerType: recordsStore.getRecords.registerType,
      nation: recordsStore.getRecords.nation,
      registerAddress: recordsStore.getRecords.registerAddress,
      addressCode: recordsStore.getRecords.addressCode,
      address: recordsStore.getRecords.address,
      signOrg: recordsStore.getRecords.signOrg,
      birthday: recordsStore.getRecords.birthday,
      job: recordsStore.getRecords.job,
      payMode: recordsStore.getRecords.payMode,
      employer: recordsStore.getRecords.employer,
      education: recordsStore.getRecords.education,
      marital: recordsStore.getRecords.marital,
      contactsName: recordsStore.getRecords.contactsName,
      contactsPhone: recordsStore.getRecords.contactsPhone,
      relation: recordsStore.userRelation,
      insuranceType: recordsStore.getRecords.insuranceType,
      insuranceNo: recordsStore.getRecords.insuranceNo,
      height: recordsStore.getRecords.height,
      weight: recordsStore.getRecords.weight,
      waistline: recordsStore.getRecords.waistline,
      onSitePhoto: recordsStore.getRecords.onSitePhoto,
      extFields: recordsStore.getRecords.extFields,
    });
    console.log('xxx-res-create', res);
  }
  // 创建 或 更新 成功 或 档案不可修改
  if (res || recordsStore.getRecords.profileStatus === ProfileStatusEnum.recorded) {
    console.log('xxx-res123', signMode !== SignModeEnum.sync, !!res.neverSign);
    if (signMode !== SignModeEnum.sync && (!!res.neverSign || contractStore?.clickBackRecords)) {
      console.log('xxx-res456', res?.profileId);
      const profileId = res?.profileId ?? recordsStore.getRecords.id;
      contractStore.setProfileId(profileId);
      if (profileId && recordsStore.userRelation) {
        await recordsStore.getRecordsForSign({ profileId, relation: Number(recordsStore.userRelation) });
      }
      // 进签约流程
      return router.push({
        name: 'contract-index',
        query: {
          type: RecordsActionTypeEnum.firstSign,
        },
      });
    }
    // 进入签约列表
    return router.push({
      name: 'sign-list',
    });
  }
}, 500);

const ins = getCurrentInstance();
onBeforeRouteLeave((to) => {
  if (!['contract-index', 'select-sign-org'].includes(String(to.name))) {
    addRouteToExclude(String(ins?.type.name));
  } else {
    recoverKeepAlive(String(ins?.type.name));
  }
});
</script>

<style lang="less" scoped>
.form-container {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 385px;
    background: linear-gradient(180deg, #fff 0%, #d6e8ff 72.4%, rgba(237, 246, 255, 0%) 100%);
  }

  .idcard-info {
    position: relative;
    z-index: 1;
    width: 654px;
    height: 252px;
  }

  .desc {
    padding: 24px 32px 0;

    p {
      margin: 0 0 24px;
      line-height: 42px;
      text-align: justify;
      font-size: 28px;
      color: var(--fda-gray-color-700);
    }

    .idcard-rule {
      width: 100%;
    }
  }
}

.form {
  display: flex;
  z-index: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  width: 100%;

  .form-title {
    padding: 0 var(--van-cell-horizontal-padding);
    width: 100%;
    height: 110px;
    background: #fff;
    line-height: 110px;
    text-align: left;
    font-weight: bold;
    font-size: 36px;
    color: var(--fda-gray-color-900);
    letter-spacing: 2px;

    .cur-step {
      color: var(--fda-primary-color);
    }
  }

  .form-box {
    width: 100%;
    background: #fff;

    :deep(.van-cell__value) {
      flex: 2;
    }
  }
}
</style>
